import axios from 'axios';
import { IS_CLIENT_SIDE } from '@dr.pogodin/react-utils';

import type { GetHistoricalUserScoresResT } from 'server/controllers/user-scores';
import { E_SCORES, P_API_USERS, type UserScoreKindT } from 'utils';

export async function getHistoricalUserScores(
  userId: string,
  kinds: UserScoreKindT[],
): Promise<GetHistoricalUserScoresResT> {
  if (!IS_CLIENT_SIDE) return null as unknown as GetHistoricalUserScoresResT;

  const res = await axios<GetHistoricalUserScoresResT>(
    `${P_API_USERS}/${userId}${E_SCORES}/historical`,
    { params: { kinds } },
  );

  return res.data;
}
